import React from "react";
import { PiUserCircleGearFill } from "react-icons/pi";
import { GrDocumentUser } from "react-icons/gr";
import { LuFileCog } from "react-icons/lu";
import { LuFileText } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { cssProperties } from "../../utils/commonCssProperties";

export default function Index() {

  const navigate = useNavigate();

  const items = [
    { icon: <PiUserCircleGearFill size={30} />, name: "CAP - COURSE MASTER", details: "(Create new course for a CAP)", path: `/${Cookies.get('mhet_mst_project')}/cap-course-management?page=capcourselist` },
    { icon: <GrDocumentUser size={30} />, name: "CAP - CANDIDATE DOCUMENT", details: "(Create new  Candidate Document for CAP)", path: `/${Cookies.get('mhet_mst_project')}/cap-candidature-document?page=candidature-documentlist` },
    { icon: <LuFileText size={30} />, name: "CAP - CATEGORY WISE DOCUMENT", details: "(Create new Category Document  for a CAP)", path: `/${Cookies.get('mhet_mst_project')}/cap-category-document?page=category-documentlist` },
    { icon: <LuFileCog size={30} />, name: "CAP COURSE DOCUMENT MASTER", details: "(Create new Course Document  for a CAP)", path: `/${Cookies.get('mhet_mst_project')}/cap-course-document-master?page=document-list` },
    

  ]

  return (
    <Grid container spacing={3} sx={{ marginTop: '12px', justifyContent: 'center' }}>
      {items.map((item, index) => (
        <Grid item xs={12} sm={6} lg={6} key={index}
          display="flex" justifyContent="center"
          onClick={() => {
            if (item?.path) {
              navigate(item.path);
            }
          }}
        >
          <Card
            sx={{
              width: '90%',
              height: '227px',
              borderRadius: "8px",
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: "none"
            }}
          >
            <Box
              sx={{
                backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`,
                color: `${cssProperties?.color?.textsecondary}`,
                border: `1px solid ${cssProperties?.bordercolor?.primary}`,
                borderRadius: '50%',
                width: '62px',
                height: '62px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '12px'
              }}
            >
              {item.icon}
            </Box>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: `${cssProperties?.fontcolor?.tableblack}`,
                  textAlign: 'center'
                }}
              >
                {item.name}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: `${cssProperties?.color?.textsecondary}`,
                  textAlign: 'center',
                }}
              >
                {item.details}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
